import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
 
const BASE_URL = process.env.REACT_APP_BASE_URL; 
export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/Auth/login",   
        method: "POST",
        body: credentials,   
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useLoginMutation } = authApi;
